module.exports = __webpack_public_path__ + "img/jobType.4bf3d101.svg";